import { UpgradeService } from './upgrade.service';

export default angular
  .module('sfMobile.services.upgrade', [])
  .service('upgradeService', UpgradeService).name;
